import { Tooltip } from '@mantine/core';
import { variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { SettingModelSettingType } from 'api/models';
import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { ConnectorPlacementAction } from 'app/modules/wallforming/components/setting-container/connector-placement/ConnectorPlacementAction';
import { PanelPlacementAction } from 'app/modules/wallforming/components/setting-container/panel-placement/PanelPlacementAction';

interface AutomatedPlacementActionProps {
    settingType: SettingModelSettingType;
}

const renderPlacementAction = (label: string, action: React.ReactNode, tooltip: string) => (
    <div className="mt-2 flex w-full flex-row items-center">
        <Tooltip label={tooltip} position="left" variant={variants.tooltip.left}>
            <div>{action}</div>
        </Tooltip>
        <div className="px-2 text-sm">{label}</div>
    </div>
);

export const AutomatedPlacementAction = ({ settingType }: AutomatedPlacementActionProps) => {
    const { t } = useTranslation();
    const shortcut = `Shortcut: ${ShortcutAction.Execute}`;

    if (settingType === SettingModelSettingType.Panels) {
        return renderPlacementAction(
            t('labelPlacePanels'),
            <PanelPlacementAction articleDataLoaded={true} />,
            shortcut
        );
    }

    if (settingType === SettingModelSettingType.Connectors) {
        return renderPlacementAction(
            t('labelPlaceConnectors'),
            <ConnectorPlacementAction articleDataLoaded={true} />,
            shortcut
        );
    }

    return null;
};
